/**
 * Native lazy-loader helper
 *
 * Adds class image--ready when image is loaded
 */

const addressbook = () => {

  const container = document.querySelector('.js-addressbook');
  if (!container) {
    return;
  }

  /**
   * Tabs
   */

  const navLinks = container.querySelectorAll('.js-addressbook__nav__button');
  const countryLists = container.querySelectorAll('.js-addressbook__list');

  for (let navLink of navLinks) {
    navLink.addEventListener('click', (e) => {

      // button state
      for (let navLinkItem of navLinks) {
        navLinkItem.classList.remove('addressbook__nav__button--active');
      }
      e.target.classList.add('addressbook__nav__button--active');

      // list state
      for (let countryList of countryLists) {

        if (countryList.getAttribute('data-country') == e.target.value) {
          countryList.classList.add('addressbook__list--active');
        } else {
          countryList.classList.remove('addressbook__list--active');
        }

      }

    });

  }

  /**
   * Toggle info
   */

  const mains = container.querySelectorAll('.js-staff__main');
  for (let main of mains) {
    main.addEventListener('click', (e) => {
      if (e.currentTarget.querySelector('.js-staff__toggle__button')) {
        e.currentTarget.querySelector('.js-staff__toggle__button').click();
      }
    });
  }

  const toggles = container.querySelectorAll('.js-staff__toggle__button');
  for (let toggle of toggles) {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();

      try {
        if (toggle.getAttribute('aria-expanded') == 'false') {
          toggle.setAttribute('aria-expanded', 'true');
          if (e.currentTarget.closest('.js-staff')) {
            e.currentTarget.closest('.js-staff').classList.add('staff--expanded');
          }
        } else {
          toggle.setAttribute('aria-expanded', 'false');
          if (e.currentTarget.closest('.js-staff')) {
            e.currentTarget.closest('.js-staff').classList.remove('staff--expanded');
          }
        }
      } catch (e) {}

    })
  }

  /**
   * Search
   */
  const form = container.querySelector('.js-addressbook__search__form');
  const input = container.querySelector('.js-addressbook__search__input');
  const submit = container.querySelector('.js-addressbook__search__submit');

  if (form && input && submit) {

    form.addEventListener('submit', (e) => {

      e.preventDefault();

      const searchQuery = input.value.toLowerCase();
      let index = [];
      const items = container.querySelectorAll('.js-addressbook__list .js-staff');
      for (let item of items) {
        if (item.getAttribute('data-index') && item.getAttribute('data-index') !== '') {
          index.push({
            item: item,
            data: item.getAttribute('data-index')
          });
        }
      }

      if (searchQuery && searchQuery !== '') {

        for (let record of index) {

          if (record.data.includes(searchQuery)) {
            record.item.classList.remove('staff--search-disabled');
            record.item.classList.add('staff--search-active');
          } else {
            record.item.classList.add('staff--search-disabled');
            record.item.classList.remove('staff--search-active');
          }

        }

      } else {

        for (let record of index) {
          record.item.classList.remove('staff--search-disabled');
          record.item.classList.add('staff--search-active');
        }

      }

      // hide empty sections
      const sections = container.querySelectorAll('.js-addressbook__list .js-addressbook__section');
      for (let section of sections) {
        if (section.querySelectorAll('.staff--search-active').length) {
          section.classList.add('addressbook__section--search-active');
          section.classList.remove('addressbook__section--search-disabled');
        } else {
          section.classList.remove('addressbook__section--search-active');
          section.classList.add('addressbook__section--search-disabled');
        }
      }

      // show none message if nothing found
      const lists = container.querySelectorAll('.js-addressbook__list');
      for (let list of lists) {
        const none = list.querySelector('.js-addressbook__none');
        if (none) {
          if (list.querySelectorAll('.addressbook__section--search-active').length) {
            none.classList.remove('addressbook__none--active');
          } else {
            none.classList.add('addressbook__none--active');
          }
        }

      }



    });

    input.addEventListener('keydown', (e) => {
      try {
        if (submit) {
          setTimeout((submit) => {
            submit.click();

            // on enter, scroll to results
            if (e.which == 13 || e.keyCode == 13) {
              container.scrollIntoView();
            }

          }, 100, submit); // without any timeout value doesn't have time to update
        }
      } catch(e) {}
    });

    submit.addEventListener('click', (e) => {
      input.focus();
    });

  }

};

addressbook();
